import Home from "@/pages/Home";
import MainNav from "@/pages/MainNav";
import Riparian from "@/pages/Riparian";
import SpatialStats from "@/pages/SpatialStats";
import UserList from "@/components/UserList";

const routes = [
  {
    path: "/",
    redirect: "/nav",
  },
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "nav",
        name: "Main",
        component: MainNav,
        children: [
          {
            path: "users",
            name: "Users",
            component: UserList,
          },
        ],
      },
      {
        path: "riparian",
        name: "Riparian",
        component: Riparian,
        children: [
          {
            path: "dummy",
          },
          {
            path: "dummy2",
          },
        ],
      },
      {
        path: "spatial-stats",
        name: "spatial-stats",
        component: SpatialStats,
      },
    ],
  },
];

export default routes;
